export enum TopicTypeEnum {
    Basic = 0,
    Picture = 1,
    Video = 2
} 